import React, {
  useRef,
  useState,
} from "react";

import {
  Store,
  MapPin,
  Phone,
  FileText,
  Send,
  X,
  CheckCircle2,
  AlertTriangle,
} from "lucide-react";

import "./VendorSignup.css";

const VendorFormModal = ({
  onClose,
}) => {

  const form = useRef();

  const [uploadedFiles,
    setUploadedFiles] =
      useState([]);

  const [sending,
    setSending] =
      useState(false);

  const [status,
    setStatus] =
      useState("");

  const [formData,
    setFormData] =
      useState({
        vendor_name: "",
        vendor_address: "",
        vendor_number: "",
        service_type: "",
      });

  const handleFileChange =
    (e) => {

    const files =
      Array.from(e.target.files);

    setUploadedFiles(files);
  };

  const handleSubmit =
    async (e) => {

    e.preventDefault();

    const data =
      new FormData();

    Object.entries(formData)
      .forEach(([key, value]) => {

      data.append(
        key,
        value
      );
    });

    uploadedFiles.forEach(
      (file) => {

      data.append(
        "files",
        file
      );
    });

    try {

      setSending(true);

      const res =
        await fetch(
"https://rcsbackend.onrender.com/send-vendor",
{
  method: "POST",

  body: data,
}
);

      const result =
        await res.json();

      setSending(false);

      if (result.success) {

        setStatus("success");

        setUploadedFiles([]);

        setFormData({
          vendor_name: "",
          vendor_address: "",
          vendor_number: "",
          service_type: "",
        });

      } else {

        setStatus("failure");
      }

    } catch (err) {

      console.error(err);

      setSending(false);

      setStatus("failure");
    }

    setTimeout(() => {

      setStatus("");

      if (
        status === "success"
      ) {
        onClose();
      }

    }, 10000);
  };

  return (

    <div className="modern-vendor-overlay">

      <div className="modern-vendor-modal">

        {/* CLOSE */}

        <button
          className="modern-vendor-close"
          onClick={onClose}
        >
          <X size={22} />
        </button>

        {/* HEADER */}

        <div className="modern-vendor-header">

          <div className="modern-vendor-icon">
            <Store size={34} />
          </div>

          <div>

            <h2>
              Vendor Sign-Up
            </h2>

            <p>
              Join the RCS vendor
              network and start
              selling today and be your own boss!
            </p>

          </div>

        </div>

        {/* NOTICE */}

        <div className="modern-vendor-alert">

          PLEASE HAVE YOUR ID,
          TIN OR DRIVER’S LICENCE
          READY BEFORE SUBMITTING
          THIS FORM.

        </div>

        {/* FORM */}

        <form
          ref={form}
          onSubmit={handleSubmit}
          className="modern-vendor-form"
        >

          <div className="modern-vendor-grid">

            <div className="modern-vendor-group">

              <label>
                Full Name
              </label>

              <div className="modern-vendor-input">

                <Store size={18} />

                <input
                  type="text"
                  name="vendor_name"
                  placeholder="Enter full name"
                  value={formData.vendor_name}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      vendor_name:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

            <div className="modern-vendor-group">

              <label>
                Contact Number
              </label>

              <div className="modern-vendor-input">

                <Phone size={18} />

                <input
                  type="tel"
                  name="vendor_number"
                  placeholder="Enter contact number"
                  value={formData.vendor_number}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      vendor_number:
                        e.target.value,
                    })
                  }
                  required
                />

              </div>

            </div>

          </div>

          <div className="modern-vendor-group">

            <label>
              Address
            </label>

            <div className="modern-vendor-input">

              <MapPin size={18} />

              <input
                type="text"
                name="vendor_address"
                placeholder="Enter address"
                value={formData.vendor_address}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    vendor_address:
                      e.target.value,
                  })
                }
                required
              />

            </div>

          </div>

          <div className="modern-vendor-group">

            <label>
              Service Type
            </label>

            <select
              name="service_type"
              value={formData.service_type}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  service_type:
                    e.target.value,
                })
              }
              required
            >

              <option value="">
                Select Service
              </option>

              <option value="Digicel">
                Digicel
              </option>

              <option value="Enet">
                Enet
              </option>

              <option value="GTT">
                GTT
              </option>

            </select>

          </div>

          <div className="modern-vendor-group">

            <label>
              Upload Documents
            </label>

            <label className="modern-upload-box">

              <FileText size={26} />

              <span>
                Upload ID, TIN or
                Driver’s Licence
              </span>

              <input
                type="file"
                name="files"
                multiple
                onChange={
                  handleFileChange
                }
              />

            </label>

          </div>

          {uploadedFiles.length >
            0 && (

            <div className="modern-file-list">

              {uploadedFiles.map(
                (file, idx) => (

                <div
                  className="modern-file-item"
                  key={idx}
                >

                  <FileText size={16} />

                  {file.name}

                </div>
              ))}

            </div>
          )}

          <div className="modern-vendor-actions">

            <button
              type="submit"
              className="modern-vendor-submit"
            >

              {sending ? (
                <>
                  <Send size={18} />
                  Sending...
                </>
              ) : (
                <>
                  <Send size={18} />
                  Submit Application
                </>
              )}

            </button>

            <button
              type="button"
              className="modern-vendor-cancel"
              onClick={onClose}
            >
              Cancel
            </button>

          </div>

        </form>

        {/* STATUS */}

        {status && (

          <div
            className={`modern-vendor-status ${
              status
            }`}
          >

            {status ===
            "success" ? (
              <>
                <CheckCircle2
                  size={72}
                />

                <h3>
                  Application Sent!
                </h3>

                <p>
                  Our team will
                  contact you shortly.
                </p>
              </>
            ) : (
              <>
                <AlertTriangle
                  size={72}
                />

                <h3>
                  Submission Failed
                </h3>

                <p>
                  Please try again later.
                </p>
              </>
            )}

          </div>
        )}

      </div>

    </div>
  );
};

export default VendorFormModal;